/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Services_TextInputs */

const en_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema offers the following subscription tiers:`)
};

const de_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema bietet folgende Abonnement-Stufen:`)
};

const fr_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema propose les niveaux d'abonnement suivants :`)
};

const es_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema ofrece los siguientes niveles de suscripción:`)
};

const it_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema offre i seguenti livelli di abbonamento:`)
};

const nl_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema biedt de volgende abonnementsniveaus:`)
};

const pl_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema oferuje następujące poziomy subskrypcji:`)
};

const fi_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema tarjoaa seuraavat tilaustasoilla:`)
};

const da_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema tilbyder følgende abonnementsniveauer:`)
};

const sv_agb_services_text = /** @type {(inputs: Agb_Services_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema erbjuder följande prenumerationsnivåer:`)
};

/**
* | output |
* | --- |
* | "Alchema offers the following subscription tiers:" |
*
* @param {Agb_Services_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_services_text = /** @type {((inputs?: Agb_Services_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Services_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_services_text(inputs)
	if (locale === "fr") return fr_agb_services_text(inputs)
	if (locale === "es") return es_agb_services_text(inputs)
	if (locale === "it") return it_agb_services_text(inputs)
	if (locale === "nl") return nl_agb_services_text(inputs)
	if (locale === "pl") return pl_agb_services_text(inputs)
	if (locale === "fi") return fi_agb_services_text(inputs)
	if (locale === "da") return da_agb_services_text(inputs)
	if (locale === "sv") return sv_agb_services_text(inputs)
	return en_agb_services_text(inputs)
});